var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 99C54.2099 99 49.4999 94.29 49.4999 88.5C49.4999 82.71 54.2099 78 59.9999 78C65.7899 78 70.4999 82.71 70.4999 88.5C70.4999 94.29 65.7899 99 59.9999 99ZM59.9999 84C57.5199 84 55.4999 86.0175 55.4999 88.5C55.4999 90.9825 57.5199 93 59.9999 93C62.4799 93 64.4999 90.9825 64.4999 88.5C64.4999 86.0175 62.4799 84 59.9999 84Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.667 52.72C99.9199 45.62 93.0774 40.03 85.3349 36.1025C77.3524 32.0525 68.8274 30 59.9999 30C51.1724 30 42.6474 32.0525 34.6649 36.1025C26.9199 40.03 20.0799 45.62 14.3324 52.72L9.66992 48.945C15.9524 41.185 23.4499 35.065 31.9524 30.7525C40.7849 26.2725 50.2224 24.0025 60.0024 24.0025C69.7824 24.0025 79.2199 26.275 88.0499 30.7525C96.5524 35.065 104.05 41.185 110.332 48.945L105.67 52.72H105.667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6049 64.295C82.7849 53.94 71.6274 48 59.9999 48C48.3724 48 37.2149 53.94 29.3949 64.295L24.6074 60.68C33.5724 48.81 46.4724 42 60.0024 42C73.5324 42 86.4299 48.8075 95.3974 60.68L90.6099 64.295H90.6049Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5524 74.735C71.6149 69.1825 65.9449 66 59.9999 66C54.0549 66 48.3849 69.185 44.4474 74.735L39.5524 71.265C44.6299 64.1075 52.0824 60 59.9999 60C67.9174 60 75.3699 64.105 80.4474 71.265L75.5524 74.735Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/Wifi.f7273611.svg";
export { ForwardRef as ReactComponent };